<!-- 快速加入合并清单弹窗 -->
<template>
    <div v-loading="loading" id="correctInventories">
        <div class="searchAp-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="sub-title">
                        <i class="el-icon-warning-outline"></i>
                        请选择合并后需要保留的商品编码，仅可选择一个保留的商品，其余未选中的商品将默认为被合并商品。
                    </div>
                </div>
            </div>
            <div class="table-ctn comg">
                <el-table
                    v-loading="loading"
                    ref="gTable"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%; margin-bottom: 10px"
                    @select="selFun"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="180" prop="APCode" label="汽配编码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="180" prop="GoodName" label="汽配名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="200" prop="AutoSerise" label="适用车型"></el-table-column>
                    <el-table-column label="操作" min-width="80"
                        ><template slot-scope="scope">
                            <el-button type="text" size="mini" @click="delGoods(scope.$index)" style="color: red">移除该项</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="dialog-footer">
                <el-button size="mini" @click="cancel()" :disabled="loading">取消</el-button>
                <el-button class="btn-primary" size="mini" :disabled="loading" @click="submitForm">生成合并清单</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {
        goodsList: {
            type: Array,
            default: () => {}
        }
    },
    data() {
        return {
            loading: false,
            tableData: [],
            keepGoods: null
        };
    },
    mounted() {
        let that = this;
        that.tableData = [...that.goodsList];
    },
    methods: {
        selFun(selection, row) {
            if (selection.length > 1) {
                this.$refs.gTable.clearSelection();
                this.$refs.gTable.toggleRowSelection(row);
            } else if (selection.length == 0) this.keepGoods = null;
            else this.keepGoods = row;
        },
        cancel() {
            this.$emit('closeDialog');
        },
        delGoods(index) {
            let that = this;
            that.tableData.splice(index, 1);
        },
        submitForm() {
            let that = this;
            if (that.loading) return;
            if (!that.tableData || that.tableData.length == 0) {
                that.$util.warningMsg('没有商品数据，请重新选择');
                return;
            }
            if (!that.keepGoods) {
                that.$util.warningMsg('请选择保留商品');
                return;
            }
            that.loading = true;
            let mergeGoodsList = [];
            that.tableData.forEach((e, i) => {
                if (e.GoodsId != that.keepGoods.GoodsId) {
                    mergeGoodsList.push({
                        KeepGoodsId: that.keepGoods.GoodsId,
                        KeepAPCode: that.keepGoods.APCode,
                        KeepGoodsName: that.keepGoods.GoodName,
                        DelGoodsId: e.GoodsId,
                        DelAPCode: e.APCode,
                        DelGoodsName: e.GoodName,
                        SortNum: i
                    });
                }
            });
            let url = '/api/EntpGoods/SaveGoodsMergeOrder';
            that.$util
                .axiosPost({
                    url: url,
                    data: { IsSumb: false, MergeGoodsList: mergeGoodsList },
                    hideLoading: true
                })
                .then(() => {
                    that.$util.successMsg('保存成功');
                    that.$emit('closeDialog');
                })
                .catch(() => {
                    that.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    overflow-y: auto;
}
.sub-title {
    color: red;
    margin-bottom: 10px;
    margin-left: 10px;
}
.dialog-footer {
    text-align: right;
}
//隐藏表头中的全选框
/deep/.el-table__header-wrapper .el-checkbox {
    display: none;
}
</style>
